import React, { Component } from 'react';
import ArrowSticker from "./ArrowSticker";

export default class ExpandableView extends Component{
    state={
        expanded:false
    };
    constructor(props) {
        super(props);
    }
    render(){
        const children = this.props.children;
        const allways=parseInt(this.props.show_allways);
        const collapsed=parseInt(this.props.show_collapsed);
        const expanded=parseInt(this.props.show_expanded);
        return (
            <div className={this.state.expanded ? this.props.cls: this.props.cls_collapsed}>
                {React.Children.map(children, (child, i) => {
                    if(allways===i)
                        return child;
                    if((this.state.expanded && i===expanded)||
                        (!this.state.expanded && i===collapsed))
                        return child;
                })}
                <ArrowSticker text="Развернуть" textOff="Свернуть" on={this.expand} off={this.collapse}/>
            </div>
        )
    }
    expand=()=>{
        this.setState({expanded:true});
    };
    collapse=()=>{
        this.setState({expanded:false});
    }
}